import { HttpParams } from '@angular/common/http';
import { ApiService } from '@libs/core/base-config';
import { omitUndefinedValues } from '@libs/core/lib/utils/utils';
import {
  Dtos,
  adminProductsListResponseSchema,
  landingPageResponseSchema,
  productSchema,
  productsListByFilterResponseSchema,
  productsListResponseSchema,
  relatedProductsListResponseSchema,
  wishListResponseSchema,
} from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function vendorGetProductById(apiService: ApiService, { id }: Dtos.VendorGetProductByIdPathParams) {
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/vendor-get-product-by-id/${id}`, {})
    .pipe(map((data) => productSchema().parse(data)));
}

export function getProductById(apiService: ApiService, { id }: Dtos.GetProductByIdPathParams) {
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/get-product-by-id/${id}`, {})
    .pipe(map((data) => productSchema().parse(data)));
}

export function productsList(apiService: ApiService, queryParams: Dtos.ProductsListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/products-list`, { params })
    .pipe(map((data) => productsListResponseSchema().parse(data)));
}

export function relatedProductsList(
  apiService: ApiService,
  queryParams: Dtos.RelatedProductsListQueryParams,
  { productId }: Dtos.RelatedProductsListPathParams,
) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/related-products-list/${productId}`, { params })
    .pipe(map((data) => relatedProductsListResponseSchema().parse(data)));
}

export function requestToPublishProduct(apiService: ApiService, { productId }: Dtos.RequestToPublishProductPathParams) {
  return apiService.http.post<void>(
    `${apiService.baseUrl}/api/v1/products/request-to-publish-product/${productId}`,
    {},
  );
}

export function unPublishProduct(apiService: ApiService, { productId }: Dtos.UnPublishProductPathParams) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/products/un-publish-product/${productId}`, {});
}

export function adminProductsList(apiService: ApiService, queryParams: Dtos.AdminProductsListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/admin-products-list`, { params })
    .pipe(map((data) => adminProductsListResponseSchema().parse(data)));
}

export function adminProductsDecision(apiService: ApiService, { decisionList }: Dtos.AdminProductsDecisionList) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/products/admin-products-decision`, { decisionList });
}

export function wishList(apiService: ApiService, queryParams: Dtos.WishListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/wish-list`, { params })
    .pipe(map((data) => wishListResponseSchema().parse(data)));
}

export function productsListByFilter(apiService: ApiService, queryParams: Dtos.ProductsListByFilterQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/products-list-by-filter`, { params })
    .pipe(map((data) => productsListByFilterResponseSchema().parse(data)));
}

export function landingPage(apiService: ApiService) {
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/products/landing-page`, {})
    .pipe(map((data) => landingPageResponseSchema().parse(data)));
}

export function productDelete(apiService: ApiService, { productId }: Dtos.ProductDeletePathParams) {
  return apiService.http.delete<void>(`${apiService.baseUrl}/api/v1/products/product-delete/${productId}`, {});
}

export function productUpdate(
  apiService: ApiService,
  { product }: Dtos.ProductUpdateBody,
  { productId }: Dtos.ProductUpdatePathParams,
) {
  return apiService.http.put<void>(`${apiService.baseUrl}/api/v1/products/product-update/${productId}`, { product });
}

export function productCreate(
  apiService: ApiService,
  { size, name, description, images, price, discount, stock, variations, bgColor }: Dtos.ProductCreateBody,
  { vendorId }: Dtos.ProductCreatePathParams,
) {
  return apiService.http
    .post(`${apiService.baseUrl}/api/v1/products/product-create/${vendorId}`, {
      size,
      name,
      description,
      images,
      price,
      discount,
      stock,
      variations,
      bgColor,
    })
    .pipe(map((data) => productSchema().parse(data)));
}
